(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["khb-clay-registration"] && !Shopify.designMode) return;
  try {
    
  function khbTranslateCountries() {
    if (!Intl.DisplayNames) return;
    const names = new Intl.DisplayNames([document.documentElement.lang || 'de'], {type: 'region'});
    document.querySelectorAll('.khb-clay-registration select').forEach(select => {
      if (!Array.from(select.options).some(option => option.value === 'DE')) return;
      Array.from(select.options).forEach(option => {
        const label = /^[A-Z]{2}$/.test(option.value) ? names.of(option.value) : (document.documentElement.lang.startsWith('de') ? 'Land auswählen' : 'Select a country');
        if (label && option.textContent !== label) option.textContent = label;
      });
    });
  }
  const khbRegistrationRoot = document.querySelector('.khb-clay-registration');
  if (khbRegistrationRoot) {
    new MutationObserver(khbTranslateCountries).observe(khbRegistrationRoot, {childList: true, subtree: true});
    khbTranslateCountries();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
